__turbopack_context__.v({
  "answerButton": "game-module__WQ-LAW__answerButton",
  "card": "game-module__WQ-LAW__card",
  "cardIn": "game-module__WQ-LAW__cardIn",
  "correctPop": "game-module__WQ-LAW__correctPop",
  "dot": "game-module__WQ-LAW__dot",
  "dotActive": "game-module__WQ-LAW__dotActive",
  "fadeOnly": "game-module__WQ-LAW__fadeOnly",
  "resultCard": "game-module__WQ-LAW__resultCard",
  "reveal": "game-module__WQ-LAW__reveal",
  "revealIn": "game-module__WQ-LAW__revealIn",
  "ringDrain": "game-module__WQ-LAW__ringDrain",
  "ringProgress": "game-module__WQ-LAW__ringProgress",
  "ringTrack": "game-module__WQ-LAW__ringTrack",
  "stagger": "game-module__WQ-LAW__stagger",
  "streakBadge": "game-module__WQ-LAW__streakBadge",
  "streakPop": "game-module__WQ-LAW__streakPop",
  "wrongShake": "game-module__WQ-LAW__wrongShake",
});
